/* Femieko LoveBox: cutia cu N produse; în coș fiecare produs primește „Bundle: <eticheta>” (pentru regula din Kite)
   și „_fe_box” (id-ul cutiei, ascuns). Fără dependențe; o instanță per secțiune. */
(() => {
  if (customElements.get('fe-lovebox')) return;

  // Ca filtrul Liquid money_without_trailing_zeros: fără zecimale când suma e întreagă (99 lei, nu 99,00 lei).
  const formatMoney = (cents, format) => {
    const value = Number(cents) / 100;
    const whole = Number(cents) % 100 === 0;
    const fmt = (decimals, thousands, dec) => {
      const fixed = value.toFixed(whole ? 0 : decimals).split('.');
      const int = fixed[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return fixed[1] ? int + dec + fixed[1] : int;
    };
    const m = (format || '{{amount}}').match(/\{\{\s*(\w+)\s*\}\}/);
    const out = {
      amount: fmt(2, ',', '.'),
      amount_no_decimals: fmt(0, ',', '.'),
      amount_with_comma_separator: fmt(2, '.', ','),
      amount_no_decimals_with_comma_separator: fmt(0, '.', ','),
      amount_with_apostrophe_separator: fmt(2, "'", '.'),
      amount_with_space_separator: fmt(2, ' ', ','),
    }[m ? m[1] : 'amount'] || fmt(2, ',', '.');
    return (format || '{{amount}}').replace(/\{\{\s*\w+\s*\}\}/, out);
  };

  const esc = (v) => String(v).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);

  class FeLovebox extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.size = Math.max(1, parseInt(this.dataset.size, 10) || 3);
      this.items = [];
      this.$ = (s) => this.querySelector(s);
      this.$$ = (s) => [...this.querySelectorAll(s)];
      this.boxId = 'lb' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
      this.addEventListener('click', (e) => this.onClick(e));
      this.addEventListener('change', (e) => this.onChange(e));
      this.$('[data-search]')?.addEventListener('input', () => this.filter());
      this.render();
    }

    t(key, n) {
      return (this.dataset['t' + key] || '').replace('[n]', n);
    }

    money(cents) {
      return formatMoney(cents, this.dataset.moneyFormat);
    }

    // varianta aleasă pe card: radio bifat, select sau input ascuns
    variantOf(card) {
      const radio = card.querySelector('input[type="radio"][data-variant]:checked');
      if (radio) return radio;
      const sel = card.querySelector('select[data-variant]');
      if (sel) return sel.selectedOptions[0];
      return card.querySelector('input[type="hidden"][data-variant]');
    }

    onChange(e) {
      const input = e.target.closest('[data-variant]');
      if (!input) return;
      const card = input.closest('.fe-lb__card');
      const v = this.variantOf(card);
      if (v) card.querySelector('[data-price]').textContent = this.money(v.dataset.price);
      this.render();
    }

    onClick(e) {
      const chip = e.target.closest('.fe-lb__chip');
      if (chip) {
        this.$$('.fe-lb__chip').forEach((c) => {
          c.classList.toggle('is-on', c === chip);
          c.setAttribute('aria-pressed', String(c === chip));
        });
        this.group = chip.dataset.group;
        return this.filter();
      }
      const add = e.target.closest('[data-add]');
      if (add) return this.add(add);
      const remove = e.target.closest('[data-remove]');
      if (remove) {
        this.items.splice(Number(remove.dataset.remove), 1);
        this.render();
        return this.status(this.t('Left', this.size - this.items.length));
      }
      const cta = e.target.closest('[data-checkout]');
      if (cta) return this.checkout(cta);
    }

    filter() {
      const q = (this.$('[data-search]')?.value || '').trim().toLowerCase();
      let visible = 0;
      this.$$('.fe-lb__card').forEach((card) => {
        const ok = (!this.group || card.dataset.group === this.group) && (!q || card.dataset.title.includes(q));
        card.hidden = !ok;
        if (ok) visible++;
      });
      this.$('[data-empty]').hidden = visible > 0;
    }

    add(btn) {
      if (this.items.length >= this.size) return this.status(this.t('Full'));
      const card = btn.closest('.fe-lb__card');
      const v = this.variantOf(card);
      if (!v || v.disabled) return;
      if (this.dataset.duplicates !== 'true' && this.items.some((i) => i.product === btn.dataset.product)) return;
      this.items.push({
        id: Number(v.value),
        product: btn.dataset.product,
        name: btn.dataset.name,
        variant: v.dataset.title || '',
        price: Number(v.dataset.price),
        image: btn.dataset.image,
      });
      this.render();
      this.status(this.items.length >= this.size ? this.t('Full') : `${this.t('Added')} · ${this.t('Left', this.size - this.items.length)}`);
      card.classList.remove('is-pop');
      void card.offsetWidth;
      card.classList.add('is-pop');
    }

    status(msg) {
      const s = this.$('[data-status]');
      if (s) s.textContent = msg;
    }

    render() {
      const n = this.items.length, full = n >= this.size;
      this.$('[data-count]').textContent = n;
      this.classList.toggle('is-full', full);

      // locurile din cutie
      this.$$('[data-slot]').forEach((slot, i) => {
        const it = this.items[i];
        slot.classList.toggle('is-filled', !!it);
        slot.innerHTML = it
          ? `<span class="fe-lb__slot-img">${it.image ? `<img src="${esc(it.image)}" alt="" width="56" height="56" loading="lazy">` : ''}</span>
             <span class="fe-lb__slot-txt"><span class="fe-lb__slot-name">${esc(it.name)}</span>${it.variant ? `<small>${esc(it.variant)}</small>` : ''}</span>
             <span class="fe-lb__slot-price">${this.money(it.price)}</span>
             <button type="button" class="fe-lb__slot-x" data-remove="${i}" aria-label="${esc(this.t('Remove') + ': ' + it.name)}"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg></button>`
          : `<span class="fe-lb__slot-img fe-lb__slot-empty">${i + 1}</span><span class="fe-lb__slot-txt fe-lb__slot-hint">${esc(this.t('EmptySlot'))}</span>`;
      });

      // totaluri
      const subtotal = this.items.reduce((a, i) => a + i.price, 0);
      const saving = full && this.dataset.saving === 'true' ? Math.min(...this.items.map((i) => i.price)) : 0;
      this.$('[data-subtotal]').textContent = this.money(subtotal);
      this.$('[data-saving-row]').hidden = !saving;
      this.$('[data-saving]').textContent = '−' + this.money(saving);
      this.$('[data-final]').textContent = this.money(subtotal - saving);

      // butonul de coș
      const cta = this.$('[data-checkout]');
      if (!cta.hasAttribute('aria-busy')) {
        cta.disabled = !full;
        cta.textContent = full ? `${this.t('Cart')} · ${this.money(subtotal - saving)}` : this.t('Left', this.size - n);
      }
      if (!this.$('[data-status]').textContent) this.status(this.t('Left', this.size - n));

      // carduri: câte bucăți sunt în cutie + butoane
      this.$$('.fe-lb__card').forEach((card) => {
        const pid = card.dataset.product;
        const count = this.items.filter((i) => i.product === pid).length;
        const badge = card.querySelector('[data-badge]');
        badge.hidden = !count;
        badge.textContent = this.t('InBox', count);
        card.classList.toggle('is-picked', count > 0);
        const btn = card.querySelector('[data-add]');
        const v = this.variantOf(card);
        const dup = this.dataset.duplicates !== 'true' && count > 0;
        btn.disabled = card.classList.contains('is-soldout') || full || dup || !v || v.disabled;
      });
    }

    async checkout(btn) {
      if (this.items.length < this.size) return;
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      const label = this.dataset.label || 'LOVE BOX';
      const items = this.items.map((it) => ({ id: it.id, quantity: 1, properties: { Bundle: label, _fe_box: this.boxId } }));
      try {
        const res = await fetch(this.dataset.cartAdd + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        });
        if (!res.ok) {
          const data = await res.json().catch(() => ({}));
          throw new Error(data.description || data.message || String(res.status));
        }
        window.location.href = this.dataset.cartUrl;
      } catch (err) {
        console.error('Femieko LoveBox', err);
        btn.removeAttribute('aria-busy');
        this.status(`${this.t('Error')} ${err.message && !/^\d+$/.test(err.message) ? '(' + err.message + ')' : ''}`.trim());
        this.render();
      }
    }
  }

  customElements.define('fe-lovebox', FeLovebox);
})();
